$(function(){

	var cms_nav_item_search_selector = '.cms-nav-item.cms-nav-item-search',
		modal_close_button_selector = '.cms-modal-close-button-wrapper',
		modal_backdrop_selector = '.cms-modal-backdrop',
		modal_search_selector = '.cms-modal-search',
		modalElement = $('.cms-modal-search');

	$(cms_nav_item_search_selector).on('click', function () {
		openModal(modalElement);
	});

	$(modal_close_button_selector).on('click', function () {
		closeModal(modalElement);
	});


});